import { 
  Box, 
  Chip, 
  CircularProgress, 
  IconButton, 
  Typography,
  Tooltip 
} from "@mui/material";
import { 
  Archive, 
  Delete, 
  Publish 
} from "@mui/icons-material";
import { useState } from "react";
import { truncateString } from "../../../../utils/truncate-string";
import { useNavigate } from "react-router-dom";
import { Assessment, AssessmentStatus } from "../../../../models/assessment";
import FirstPublishDialog from "./first-publish-dialog";
import DeleteAssessmentDialog from "./delete-assessment-dialog";

interface AssessmentCardProps {
  assessment: Assessment;
  // updateAssessment: (assessment: Assessment) => void;
  onDelete: (assessment_id: number) => void;
  runningTask: number | null;
}

export default function AssessmentCard({ 
  assessment, 
  // updateAssessment, 
  onDelete,
  runningTask
}: AssessmentCardProps) {
  const navigate = useNavigate();
  const [isPublishDialogOpen, setIsPublishDialogOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  
  // const handleUpdateAssessment = async () => {
  //   setIsLoading(true);
  //   try {
  //     updateAssessment(assessment);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  // const handleStatusToggle = (targetStatus: AssessmentStatus) => {
  //   if (targetStatus === AssessmentStatus.ARCHIVED) {
  //     assessment.status = AssessmentStatus.ARCHIVED;
  //     handleUpdateAssessment();
  //   } else {
  //     if (assessment.status === AssessmentStatus.ARCHIVED) {
  //       assessment.status = AssessmentStatus.PUBLISHED;
  //       handleUpdateAssessment();
  //     } else {
  //       setIsPublishDialogOpen(true);
  //     }
  //   }
  // };

  // const handlePublish = () => {
  //   setIsPublishDialogOpen(false);
  //   assessment.status = AssessmentStatus.PUBLISHED;
  //   handleUpdateAssessment();
  // };

  const handleCardClick = () => {
    if (isDeleteDialogOpen || isPublishDialogOpen || runningTask === assessment.id) return;
    navigate(`/classroom/${assessment.classroom_id}/assessments/${assessment.id}`);
  };

  const getStatusChipProps = (status: AssessmentStatus) => {
    switch (status) {
      case AssessmentStatus.PUBLISHED:
        return {
          label: "Published",
          sx: {
            backgroundColor: '#e8f5e8',
            color: '#2e7d32',
            fontWeight: 500,
          }
        };
      case AssessmentStatus.ARCHIVED:
        return {
          label: "Archived",
          sx: {
            backgroundColor: '#f5f5f5',
            color: '#616161',
            fontWeight: 500,
          }
        };
      default:
        return {
          label: "Draft",
          sx: {
            backgroundColor: '#f5f5f5',
            color: '#616161',
            fontWeight: 500,
          }
        };
    }
  };

  const isPublished = assessment.status === AssessmentStatus.PUBLISHED;
  const chipProps = getStatusChipProps(assessment.status);

  return (
    <Box
      sx={{
        p: 2,
        borderRadius: 2,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: 80,
        backgroundColor: "white",
        border: 1,
        borderColor: isPublished ? 'success.main' : 'grey.300',
        cursor: 'pointer',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          transform: 'translateY(-1px)',
          boxShadow: 2,
          borderColor: isPublished ? 'success.dark' : 'grey.400',
        },
      }}
      onClick={handleCardClick}            
    >
      {/* Header Section */}
      <Box sx={{ mb: 1 }}>
        <Typography 
          variant="subtitle1"
          sx={{
            fontWeight: 600,
            color: 'text.primary',
            lineHeight: 1.2,
          }}
        >
          {truncateString(assessment.title, 30)}
        </Typography>
      </Box>

      {/* Footer Section */}
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        mt: 'auto'
      }}>
        <Chip
          {...chipProps}
          size="small"
          sx={{
            ...chipProps.sx,
            fontSize: '0.75rem',
            height: 24,
            textTransform: 'none',
          }}
        />

        <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
          {isLoading ? (
            <CircularProgress size={16} color="inherit" />
          ) : (
            <>
              {/* <Tooltip title={isPublished ? "Archive Assessment" : "Publish Assessment"}>
                <IconButton
                  onClick={(event) => {
                    event.stopPropagation();
                    handleStatusToggle(
                      isPublished ? AssessmentStatus.ARCHIVED : AssessmentStatus.PUBLISHED
                    );
                  }}
                  size="small"
                  sx={{
                    color: isPublished ? 'warning.main' : 'success.main',
                    backgroundColor: isPublished ? '#f5dcab' : '#d1fabb',
                    borderRadius: 2,
                    '&:hover': {
                      backgroundColor: isPublished ? 'warning.main' : 'success.main',
                      color: 'white',
                    },
                    transition: 'all 0.15s ease',
                  }}
                >
                  {isPublished ? (
                    <Archive sx={{ fontSize: 18 }} />
                  ) : (
                    <Publish sx={{ fontSize: 18 }} />
                  )}
                </IconButton>
              </Tooltip> */}

               {runningTask === assessment.id ? (
                  <CircularProgress size={18} />
               ) : (
                  <Tooltip title="Delete Assessment">
                    <IconButton
                      onClick={(event) => {
                        event.stopPropagation();
                        setIsDeleteDialogOpen(true);
                      }}
                      size="small"
                      sx={{
                        color: 'error.main',
                        backgroundColor: '#fccac5',
                        borderRadius: 2,
                        '&:hover': {
                          backgroundColor: 'error.main',
                          color: 'white',
                        },
                        transition: 'all 0.15s ease',
                      }}
                    >
                      <Delete sx={{ fontSize: 18 }} />
                    </IconButton>
                  </Tooltip>
                )} 
            </>
          )}
        </Box>
      </Box>

      {/* Dialogs */}
      {/* <FirstPublishDialog
        open={isPublishDialogOpen}
        setOpen={setIsPublishDialogOpen}
        updateFunction={handlePublish}
      /> */}

      <DeleteAssessmentDialog
        open={isDeleteDialogOpen}
        setOpen={setIsDeleteDialogOpen}
        assessment={assessment}
        deleteFunction={onDelete}
      />
    </Box>
  );
}